<template>
  <div class="NavigationLine__Container">
    <div :class="['NavigationLine__Line', selected ? '' : 'NavigationLine__Line_Unselected']">
      <div class="Arrow" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    selected: { type: Boolean, default: false }
  }
}
</script>

<style scoped>

@media screen and (min-width: 1200px) {
  .NavigationLine__Container{
      height: 50px;
      width: 100%;
      margin-left: 8px;
      margin-right: 8px;
      display: flex;
      justify-content: center;
  }
}

@media screen and (max-width: 1200px) {
  .NavigationLine__Container{
      height: 45px;
      width: 100%;
      margin-left: 8px;
      margin-right: 8px;
      display: flex;
      justify-content: center;
  }
}

.NavigationLine__Line{
    height: 2px;
    width: 100%;
    align-self: center;
    background: black;
    position: relative;
}

.NavigationLine__Line_Unselected {
    opacity: 0.15;
}

.Arrow {
  position: absolute;
  right: -2px;
  top: -3px;
  background: black;
  margin-top: auto;
  margin-bottom: auto;
  width: 8px;
  height: 8px;
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: contain;
  mask-image: url('../../../assets/icons/triangle.svg');
  transform: rotate(90deg);
}
</style>
